import variables from 'variables.module.scss';

export const Pagination = {
  itemActiveBg: variables.primaryDarkColor,
};
